import { StreamHandler } from "./stream.handler";
import { SubscribeCampaigns, UpdateCampaigns } from "@/types";
import type { PublicCampaignSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeAssembledCampaigns } from "@/stores/derive";

/**
 * `campaigns` — the type-agnostic structural stream (all served campaign types).
 * Feeds `campaignsById`; every push is the full tile list. Assembled views (prize
 * drops and tournaments) are re-derived on change.
 */
export class CampaignsHandler extends StreamHandler<PublicCampaignSchema[]> {
  protected readonly subscribeType = SubscribeCampaigns;
  protected readonly updateType = UpdateCampaigns;

  protected isBusy(): boolean {
    const s = useAppStore.getState().campaignsStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setCampaignsLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setCampaignsSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearCampaigns();
    recomputeAssembledCampaigns();
  }
  protected apply(data: PublicCampaignSchema[]): void {
    useAppStore.getState().setCampaigns(data);
    recomputeAssembledCampaigns();
  }
}

export const campaignsHandler = new CampaignsHandler();
